import { render, staticRenderFns } from "./AverageTreatmentByGenderAndAge.vue?vue&type=template&id=154d8bc8&"
import script from "./AverageTreatmentByGenderAndAge.vue?vue&type=script&lang=js&"
export * from "./AverageTreatmentByGenderAndAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports